export default function PdfViewerModal({

  isOpen,

  onClose,

  documentType,

  title,

  subtitle,

  date,

  pdfUrl,

  onWhatsApp,

  sendingWhatsApp = false

}) {

  if (!isOpen) {
    return null;
  }

  return (

    <div

      onClick={onClose}

      style={{

        position:"fixed",

        inset:0,

        background:
          "rgba(0,0,0,0.6)",

        display:"flex",

        alignItems:"center",

        justifyContent:"center",

        zIndex:9999

      }}

    >

      <div

        onClick={e =>
          e.stopPropagation()
        }

        style={{

          width:"90vw",

          maxWidth:"1100px",

          height:"90vh",

          background:"#fff",

          borderRadius:16,

          display:"flex",

          flexDirection:"column",

          overflow:"hidden"

        }}

      >

        <div style={{

            padding:"14px 18px",

            borderBottom:
                "1px solid #e5e7eb",

            display:"flex",

            justifyContent:
                "space-between",

            alignItems:"center",

            flexWrap:"wrap",

            gap:10

            }}>

            <div>

                {documentType && (

                    <div style={{

                    fontSize:12,

                    fontWeight:700,

                    color:"#6b7280",

                    textTransform:"uppercase",

                    marginBottom:4

                    }}>

                    {documentType}

                    </div>

                )}

                <div style={{

                    fontSize:18,

                    fontWeight:700

                }}>

                    {title}

                </div>

                {subtitle && (

                    <div style={{

                    fontSize:14,

                    color:"#4b5563",

                    marginTop:2

                    }}>

                    {subtitle}

                    </div>

                )}

                {date && (

                    <div style={{

                    fontSize:12,

                    color:"#6b7280",

                    marginTop:4

                    }}>

                    {date}

                    </div>

                )}

                </div>

            <div style={{

                display:"flex",

                gap:10,

                alignItems:"center"

            }}>

                <a

                href={pdfUrl}

                download

                target="_blank"

                rel="noreferrer"

                style={{

                    padding:"8px 12px",

                    background:"#e5e7eb",

                    borderRadius:8,

                    textDecoration:"none",

                    color:"#111827",

                    fontWeight:600

                }}

                >

                Descargar

                </a>

                <button

                onClick={onWhatsApp}

                disabled={
                    sendingWhatsApp
                }

                style={{

                    padding:"8px 12px",

                    background:"#16a34a",

                    color:"#fff",

                    border:"none",

                    borderRadius:8,

                    cursor:"pointer",

                    fontWeight:600,

                    opacity:
                    sendingWhatsApp
                        ? 0.6
                        : 1

                }}

                >

                {

                    sendingWhatsApp

                    ? "Enviando..."

                    : "WhatsApp"

                }

                </button>

                <button

                onClick={onClose}

                style={{

                    border:"none",

                    background:"transparent",

                    fontSize:22,

                    cursor:"pointer",

                    fontWeight:700

                }}

                >

                ✕

                </button>

            </div>

            </div>

        <iframe

          title="pdf-viewer"

          src={pdfUrl}

          style={{

            flex:1,

            width:"100%",

            border:"none"

          }}

        />

      </div>

    </div>

  );

}